/** Hợp đồng dây của module `bien-ban` (ADR-0126 mục 5): `snake_case`, thời gian tính bằng giây. */

export const TRANG_THAI_PHIEN = ['QUEUED', 'TRANSCRIBING', 'SUMMARIZING', 'DONE', 'FAILED'] as const;
export type TrangThaiPhien = (typeof TRANG_THAI_PHIEN)[number];

export type TrangThaiTomTat = 'NONE' | 'PENDING' | 'DONE' | 'FAILED';
export type DoTinCay = 'high' | 'medium' | 'low';

export interface NguoiNoi {
  label: string;
  name: string | null;
  speech_seconds: number;
}

export interface ViecCanLam {
  task: string;
  owner: string | null;
  due: string | null;
}

export interface TomTat {
  overview: string;
  key_points: string[];
  decisions: string[];
  action_items: ViecCanLam[];
  edited: boolean;
}

export type TomTatGhi = Omit<TomTat, 'edited'>;

export interface Phien {
  id: string;
  title: string;
  status: TrangThaiPhien;
  file_name: string;
  file_size: number;
  content_type: string;
  language: string | null;
  duration_seconds: number | null;
  num_speakers: number | null;
  speakers: NguoiNoi[];
  reliability: DoTinCay | null;
  reliability_note: string | null;
  error_code: string | null;
  error_message: string | null;
  summary_status: TrangThaiTomTat;
  summary_error: string | null;
  summary: TomTat | null;
  created_at: string;
  updated_at: string;
  created_by: string;
  created_by_name: string | null;
}

export interface TrangPhien {
  items: Phien[];
  next_cursor: string | null;
}

export interface Doan {
  id: string;
  index: number;
  start: number;
  end: number;
  speaker: string | null;
  text: string;
  edited: boolean;
}

export interface TrangDoan {
  items: Doan[];
  next_cursor: string | null;
}

export interface AmThanhKy {
  url: string;
  expires_in: number;
}

export type NgonNguPhien = 'auto' | 'vi' | 'en';

export interface PhienTao {
  file: File;
  title: string;
  /** `auto` là để máy tự nhận diện: không gửi trường `language`. */
  language: NgonNguPhien;
  num_speakers?: number;
}

export interface PhienSua {
  title?: string;
  speakers?: Record<string, string>;
}

export interface DoanSua {
  text?: string;
  speaker?: string;
}

export type DinhDangXuat = 'docx' | 'txt';
